module.exports = __webpack_public_path__ + "assets/img/sbx.f50167a1.png";